'use strict'
const isEmpty_ = require('lodash/isEmpty')
const DATASET_TYPES = require('dbsm-common/src/datasetTypes')
const {
  isDatasetConfigured,
  getReadWriteMode
} = require('../dataset-controller/rootReducer')

const reportDatasetActiveOnPage = (
  biLogger,
  state,
  connections,
  datasetType,
  isScoped,
  uniqueId,
  wixSdk
) => {
  if (
    !isScoped &&
    !isEmpty_(connections) &&
    wixSdk.window.viewMode !== 'Preview' &&
    isDatasetConfigured(state)
  ) {
    biLogger({
      evid: datasetType === DATASET_TYPES.ROUTER_DATASET ? 135 : 134,
      mode: getReadWriteMode(state),
      page_url: wixSdk.location.url,
      viewmode: wixSdk.window.viewMode,
      ds_id: uniqueId, // we do not yet get the real dataset id
      ds_type: datasetType
    })
  }
}

module.exports.reportDatasetActiveOnPage = reportDatasetActiveOnPage



// WEBPACK FOOTER //
// ./bi/events.js